import { Digit, Fraction, ShaftTippingFraction } from '@/api/models';
import { sortByPropKey } from '@/utils';

export interface ShaftTippingOption {
  digit: string;
  joinTableDigitId: number;
  sourceTableDigitId: number | null;
  fraction: string;
  joinTableFractionId: number;
  sourceTableFractionId: number | null;
}

export interface ShaftTippingOptionMap {
  map: Record<string, ShaftTippingOption>;
  options: { id: string; label: string }[];
}

interface IBuildDropdownData {
  fractionJoinTable: ShaftTippingFraction[];
  digitSourceTable: Digit[];
  fractionSourceTable: Fraction[];
}

interface ShaftTippingDigit {
  shaftTippingDigitId: number;
  digitId: number;
  name: string;
}

// There is no ShaftTippingDigit database table
// These values are hardcoded in the current app
const SHAFT_TIPPING_DIGITS = ['0', '1', '2', '3'];

export const buildDropdownData = ({ fractionJoinTable, digitSourceTable, fractionSourceTable }: IBuildDropdownData) => {
  const digitJoinTable: ShaftTippingDigit[] = SHAFT_TIPPING_DIGITS.map((hardcodedDigit) => {
    const digitSource = digitSourceTable.find((digit) => digit.name === hardcodedDigit);
    if (!digitSource) throw new Error('Missing digit source');
    return {
      shaftTippingDigitId: Number(hardcodedDigit),
      digitId: digitSource?.digitId,
      name: hardcodedDigit,
    };
  });
  return digitJoinTable.sort(sortByPropKey<ShaftTippingDigit>('shaftTippingDigitId')).reduce<ShaftTippingOptionMap>(
    (acc, digitJoinTableItem) => {
      fractionJoinTable.forEach((fractionJoinTableItem) => {
        const fractionEntity = fractionSourceTable.find((f) => f.fractionId === fractionJoinTableItem.fractionId);
        const displayName = `${digitJoinTableItem?.name} ${fractionEntity?.name}`;

        const option: ShaftTippingOption = {
          digit: digitJoinTableItem?.name || '',
          joinTableDigitId: digitJoinTableItem.digitId,
          sourceTableDigitId: digitJoinTableItem?.digitId || null,
          fraction: fractionEntity?.name || '',
          joinTableFractionId: fractionJoinTableItem.shaftTippingFractionId,
          sourceTableFractionId: fractionEntity?.fractionId || null,
        };

        acc.map[displayName] = option;
        acc.options.push({ id: displayName, label: displayName });
      });

      return acc;
    },
    { map: {}, options: [] },
  );
};
